import React, { FC } from 'react'
import logo from './logo.png'
import { ReactComponent as LogoSVG } from './logo.svg'
import logoAnimated from './BrightTALK-Logo-Grad-Indigo_rgb.svg'

interface LogoProps {
  animated?: boolean
  className?: string
  svg?: boolean
  width?: number
  height?: number
  url?: string
}

const Logo: FC<LogoProps> = ({ svg = false, animated = false, className = '', height, width, url }) => {

  if (url) {

    return <img src={url} alt="BrightTALK" className={className} height={height} width={width} />

  }

  return svg && !animated
  ? <LogoSVG className={className} height={height} width={width} />
  : <img src={animated ? logoAnimated : logo} alt="BrightTALK" className={className} height={height} width={width} />

}

export default Logo
